module.exports = __webpack_public_path__ + "img/32.b86e5d4f.jpg";